import { Theme } from "@mui/material";

export const PositionStyles = (theme: Theme) => {
  return {
    bottom: {
      "img": {
        width: "100%",
        height: "60%",
      },
    },
    right: {
      "img": {
        width: "100%",
        height: "100%",
      },
    },
    top: {
      "img": {
        width: "100%",
        height: "200%",
      },
    },
  };
};
